import React, { useState } from "react";
import Icon from "@/components/Icon";
import "./translate.scss";

interface data {
  localInstruction: string | undefined;
  instruction: string | undefined;
  activityType?: string;
}

const Translate: React.FC<data> = ({ localInstruction, instruction }) => {
  const [translate, setTranslate] = useState(false);
  return (
    <div className="translate">
      <h1>{translate ? localInstruction : instruction || "Fill in the Gap"}</h1>
      {localInstruction !== undefined && (
        <div
          className="translate_btn"
          onClick={() => {
            setTranslate(!translate);
          }}
        >
          <Icon name="language" />
        </div>
      )}
    </div>
  );
};

export default Translate;
